import PolicyLayout, { PolicySection } from "@/components/policy/PolicyLayout";

export default function TermsAndConditions() {
  return (
    <PolicyLayout
      testId="terms-page"
      overline="Legal · Policies"
      title="Terms &amp; "
      italicWord="Conditions."
      updated="July 2026"
      intro="Please read these Terms &amp; Conditions carefully before using innayaa.in. By accessing or purchasing from our website, you agree to be bound by these terms."
    >
      <PolicySection n="1" title="About Innayaa">
        <p>
          The website <strong className="text-[#2A2626]">innayaa.in</strong> (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) is
          operated by Innayaa, a handcrafted semi-precious jewellery brand based in India.
          These Terms &amp; Conditions govern your use of our website, products, and services.
        </p>
      </PolicySection>

      <PolicySection n="2" title="Eligibility">
        <p>
          By placing an order on innayaa.in you confirm that you are at least{" "}
          <strong className="text-[#2A2626]">18 years of age</strong> or are placing the order
          under the supervision of a parent or legal guardian, and that the information you
          provide (name, address, phone, email) is true, accurate, and complete.
        </p>
      </PolicySection>

      <PolicySection n="3" title="Products & Handmade Nature">
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Every Innayaa piece is <strong className="text-[#2A2626]">individually handcrafted</strong> with
            semi-precious stones, freshwater pearls, and 925 sterling silver ear hooks.
          </li>
          <li>
            Minor variations in colour, texture, cut of stones, or placement of chain are{" "}
            <strong className="text-[#2A2626]">natural characteristics of handmade craft</strong>{" "}
            and should not be considered defects.
          </li>
          <li>
            Product images are shot as accurately as possible; slight colour differences may
            occur due to your screen&rsquo;s display, lighting, and natural stone variation.
          </li>
          <li>
            All prices are listed in <strong className="text-[#2A2626]">Indian Rupees (₹)</strong> and are
            inclusive of applicable taxes unless stated otherwise.
          </li>
        </ul>
      </PolicySection>

      <PolicySection n="4" title="Orders & Acceptance">
        <ul className="list-disc pl-5 space-y-2">
          <li>
            An order confirmation email is an acknowledgement of your request — it does not
            constitute acceptance of the order. Innayaa reserves the right to accept or
            decline any order at its sole discretion.
          </li>
          <li>
            We may cancel or refuse orders in cases of suspected fraud, pricing errors,
            stock unavailability, or non-serviceable pincodes.
          </li>
          <li>
            If an order you have paid for is cancelled by us, the amount will be refunded
            to your original payment method within a reasonable timeframe.
          </li>
        </ul>
      </PolicySection>

      <PolicySection n="5" title="Payments">
        <ul className="list-disc pl-5 space-y-2">
          <li>
            All orders on innayaa.in are paid <strong className="text-[#2A2626]">online only</strong> via
            our trusted third-party payment gateway (UPI, cards, net banking, and wallets).
          </li>
          <li>
            Innayaa does not store your card or banking details on our servers — all
            sensitive information is handled securely by the payment gateway.
          </li>
          <li>
            Any transaction fees or charges levied by your bank or payment provider are
            your responsibility.
          </li>
        </ul>
      </PolicySection>

      <PolicySection n="6" title="Shipping, Returns & Exchanges">
        <p>
          Shipping timelines, charges, and coverage are governed by our{" "}
          <a href="/shipping-policy" className="text-[#2A2626] link-underline">
            Shipping Policy
          </a>
          . Refunds, returns, and exchanges are governed by our{" "}
          <a href="/return-exchange-policy" className="text-[#2A2626] link-underline">
            Return &amp; Exchange Policy
          </a>
          . By placing an order you agree to both.
        </p>
      </PolicySection>

      <PolicySection n="7" title="Intellectual Property">
        <p>
          All content on innayaa.in — including product photography, videos, copy, logos,
          the Innayaa name and mark, and page design — is the exclusive property of Innayaa
          and is protected by copyright and trademark law. You may not copy, reproduce,
          modify, distribute, or use any of this content for commercial purposes without
          our prior written consent.
        </p>
      </PolicySection>

      <PolicySection n="8" title="User Conduct">
        <p>You agree not to use innayaa.in to:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Post or transmit unlawful, harmful, defamatory, or fraudulent content.</li>
          <li>Impersonate any person or misrepresent your identity.</li>
          <li>Interfere with, disrupt, or attempt to gain unauthorised access to our systems.</li>
          <li>Use bots, scrapers, or automated tools to access our website or place orders.</li>
        </ul>
      </PolicySection>

      <PolicySection n="9" title="Limitation of Liability">
        <p>
          To the maximum extent permitted by law, Innayaa shall not be liable for any
          indirect, incidental, or consequential damages arising out of the use of our
          website or products. Our total liability in any circumstance will not exceed the
          value of the order in question.
        </p>
      </PolicySection>

      <PolicySection n="10" title="Governing Law & Jurisdiction">
        <p>
          These Terms &amp; Conditions are governed by the laws of India. Any disputes arising
          out of or in connection with these terms shall be subject to the exclusive
          jurisdiction of the courts of India.
        </p>
      </PolicySection>

      <PolicySection n="11" title="Changes to These Terms">
        <p>
          We may update these Terms &amp; Conditions from time to time. Any changes will be
          posted on this page with an updated &ldquo;Last updated&rdquo; date. Continued use of the
          website after such changes constitutes acceptance of the updated terms.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
